import { Component, Input } from '@angular/core';
import { AppDataService, ConfigService, MerchantService } from 'app/services';
import { ImageCroppedEvent, LoadedImage } from 'ngx-image-cropper';
import { MenuItem, MessageService } from 'primeng/api';

enum UploadImageTab {
    Logo = 1,
    Cover = 2
}

@Component({
    selector: 'upload-store-image',
    templateUrl: './upload-store-image.component.html',
    styleUrls: ['./upload-store-image.component.scss']
})
export class UploadStoreImageComponent {
    constructor(private appData: AppDataService, public configService: ConfigService, private merchantService: MerchantService, public messageService: MessageService) { }

    @Input()
    public visible: boolean = false;

    @Input()
    public onHide: () => void = () => { };

    public cancel() {
        this.onHide();
    }
    public activeTab: UploadImageTab = UploadImageTab.Logo;
    public uploadImageTab = UploadImageTab;

    public menuItems: MenuItem[] = [
        {
            label: 'Logo',
            id: `${UploadImageTab.Logo}`,
            command: (e: any) => this.handleTabChange(+e.item.id)
        },
        {
            label: 'Store Cover Image',
            id: `${UploadImageTab.Cover}`,
            command: (e: any) => this.handleTabChange(+e.item.id)
        }
    ];

    public handleTabChange(tab: UploadImageTab) {
        this.activeTab = tab;
    }

    public loading: boolean = false;

    public showImageCropper: boolean = false;
    imageChangedEvent: any = '';
    croppedImage: any = '';
    public croppedLogo: string = '';
    public croppedCover: string = '';

    fileChangeEvent(event: any): void {
        this.imageChangedEvent = event;
        this.showImageCropper = true;
    }

    imageCropped(event: ImageCroppedEvent) {
        this.croppedImage = event.blob;
        const reader = new FileReader();
        reader.onload = this.handleReaderLoaded.bind(this);
        reader.readAsDataURL(this.croppedImage);

        console.log(this.croppedImage);
        // event.blob can be used to upload the cropped image
    }
    private handleReaderLoaded(e: any) {
        const reader = e.target;
        this.croppedImage = reader.result;
    }
    imageLoaded(image: LoadedImage) {
        // show cropper
    }
    cropperReady() {
        // cropper ready
    }
    loadImageFailed() {
        // show message
    }
    public handleUploadClick() {
        document.getElementById('idImgInput')?.click();
    }
    public saveCroppedImage() {
        if (this.activeTab === this.uploadImageTab.Cover) {
            this.croppedCover = this.croppedImage;
        }
        else if (this.activeTab === this.uploadImageTab.Logo) {
            this.croppedLogo = this.croppedImage;
        }
        console.log(this.croppedImage);
        this.croppedImage = '';
        this.imageChangedEvent = null;
        this.showImageCropper = false;
    }

    public changeMerchantImage() {
        const dto = {
            MerchantId: this.appData.authData.MerchantId,
            StoreImageUrl: '',
            CoverImageUrl: ''
        };

        if (this.activeTab === this.uploadImageTab.Cover) {
            dto.CoverImageUrl = this.croppedCover;
        }
        else if (this.activeTab === this.uploadImageTab.Logo) {
            dto.StoreImageUrl = this.croppedLogo;
        }

        this.loading = true;
        this.merchantService.changeMerchantImage(dto, this.messageService)
            .then(data => {
                if (!data.Success) {
                    this.loading = false;
                    this.messageService.add({ severity: 'error', summary: 'Error', detail: data.ErrorMessage });
                    return;
                }

                this.loading = false;
                this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Image has been uploaded' });
                if (this.activeTab === this.uploadImageTab.Cover) {
                    this.croppedCover = '';
                }
                else if (this.activeTab === this.uploadImageTab.Logo) {
                    this.croppedLogo = '';
                }
            })
            .catch(err => {
                this.loading = false;
                throw err;
            });
    }
}
